<template lang="html">
    <div class="contactLunch">
        <slot name="title"></slot>
        <div class="form-group">
            <slot name="label"></slot>
            <div class="input-group">
                <input
                    :id="'lunch_' + id"
                    class="input-group__input input--size2"
                    type="number"
                    :name="'lunches[' + id + ']'"
                    :data-id="id"
                    @change="onChange"
                    v-model.number="thisContactLunchesNumber"
                    min="0"
                    :max="maxContactLunches"
                    @keydown.enter.prevent
                >
            </div>
        </div>
        <div class="form-group">
            <label
                :for="'extra_' + id"
            >{{ labelExtra }} (max {{ getMaxExtra }})
            </label>
            <div class="input-group">
                <input
                    :id="'extra_' + id"
                    class="input-group__input input--size2"
                    type="number"
                    :name="'extra[' + id + ']'"
                    :data-id="id"
                    @change="onChange"
                    v-model.number="thisContactLunchesExtraNumber"
                    min="0"
                    :max="getMaxExtra"
                    @keydown.enter.prevent
                >
            </div>
        </div>
        <div class="form-group">
            <div class="contactLunch__calculate">
                <label>Total</label>
                <span>{{ thisContactLunchesNumber }} {{ labelEmployee }},</span><br>
                <span>{{ totalStudents }} {{ labelStudent }}</span>
                <!--<p class="section__infos">
                    <svg viewBox="0 0 24 24">
                        <use xlink:href="#information"></use>
                    </svg>
                    {{ remainingLunches }} {{ labelRemainingLunches }}
                </p>-->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: String,
        contactLunchesNumber: String,
        contactLunchesExtraNumber: String,
        target: String,
        labelEmployee: String,
        labelStudent: String,
        labelExtra: String,
        labelRemainingLunches: String,
        maxContactLunches: String,
        nbStudentsPerRecruiter: Number,
        nbMaxExtra: Number,
        change: Function,
        changeExtra: Function
    },
    data() {
        return {
            thisContactLunchesNumber: this.contactLunchesNumber,
            thisContactLunchesExtraNumber: this.contactLunchesExtraNumber
        }
    },
    methods: {
        onChange: function () {
            if (this.thisContactLunchesExtraNumber > this.getMaxExtra) {
                this.thisContactLunchesExtraNumber = this.getMaxExtra
            }
            this.$root.updateOrderItemQuantity('ordersummarytable,recap-order-table', 'lunch', Number(this.id), Number(this.thisContactLunchesNumber));
            this.$root.updateOrderItemQuantity('ordersummarytable,recap-order-table', 'extra', Number(this.id), Number(this.thisContactLunchesExtraNumber));
            if (this.change) {
                this.change(Number(this.thisContactLunchesNumber));
            }
            if (this.changeExtra) {
                this.changeExtra(Number(this.thisContactLunchesExtraNumber));
            }
        },

    },
    computed: {
        remainingLunches: function () {
            let nbAvailable = +this.contactLunchesNumber + +this.maxContactLunches - +this.thisContactLunchesNumber;
            return nbAvailable > 0 ? nbAvailable : 0;
        },
        totalStudents: function () {
            if (this.thisContactLunchesExtraNumber > 0) {
                return (this.thisContactLunchesNumber * this.nbStudentsPerRecruiter) + Number(this.thisContactLunchesExtraNumber)
            }
            return this.thisContactLunchesNumber * this.nbStudentsPerRecruiter
        },
        getMaxExtra: function () {
            return Number(this.thisContactLunchesNumber) * this.nbMaxExtra
        }
    }
}
</script>

<style lang="css" scoped>
</style>
